var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMathPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6416 0H4.3584C4.2548 0 4.15544 0.0411986 4.08218 0.114533C4.00893 0.187867 3.96777 0.287329 3.96777 0.391039V3.96611H0.389648C0.286048 3.96611 0.186691 4.00731 0.113435 4.08064C0.0401783 4.15398 -0.000976562 4.25344 -0.000976562 4.35715V7.64285C-0.000976562 7.74656 0.0401783 7.84602 0.113435 7.91936C0.186691 7.99269 0.286048 8.03389 0.389648 8.03389H3.96875V11.6099C3.96875 11.7136 4.0099 11.8131 4.08316 11.8864C4.15642 11.9598 4.25577 12.001 4.35938 12.001H7.6416C7.7452 12.001 7.84456 11.9598 7.91782 11.8864C7.99107 11.8131 8.03223 11.7136 8.03223 11.6099V8.03389H11.6094C11.713 8.03389 11.8123 7.99269 11.8856 7.91936C11.9588 7.84602 12 7.74656 12 7.64285V4.35617C12 4.25246 11.9588 4.153 11.8856 4.07966C11.8123 4.00633 11.713 3.96513 11.6094 3.96513H8.03223V0.391039C8.03223 0.287329 7.99107 0.187867 7.91782 0.114533C7.84456 0.0411986 7.7452 0 7.6416 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathPlusIcon);
export default __webpack_public_path__ + "static/media/math-plus-icon.88476d0105a23c4aff8b409d02cba406.svg";
export { ForwardRef as ReactComponent };